import {
  DEVICE_HIBERNATING,
  DEVICE_NEEDS_UPGRADE,
  DEVICE_OFFLINE,
  DEVICE_ONLINE,
  TOTAL_HIBERNATING_KEY,
  TOTAL_NEEDS_SOFTWARE_UPGRADE_KEY,
  TOTAL_ONLINE_KEY,
  TOTAL_OFFLINE_KEY,
} from "constant/device-status";
import PropTypes from "prop-types";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { InfoBox } from "ui/info-box";

class DeviceStats extends React.PureComponent {
  static get propTypes() {
    return {
      children: PropTypes.node,
      deviceStats: PropTypes.object,
      deviceStatusOnline: PropTypes.bool,
    };
  }

  constructor() {
    super();

    this.onlineTitle = `${DEVICE_ONLINE.label} | ${DEVICE_HIBERNATING.label}`;
  }

  renderChild(colWidth, child) {
    return React.cloneElement(child, { xs: colWidth });
  }

  render() {
    const { children, deviceStats, deviceStatusOnline } = this.props;

    const totalHibernating = deviceStats[TOTAL_HIBERNATING_KEY];
    const totalOnline = deviceStats[TOTAL_ONLINE_KEY];
    const totalOffline = deviceStats[TOTAL_OFFLINE_KEY];
    const totalNeedsSoftwareUpgrade =
      deviceStats[TOTAL_NEEDS_SOFTWARE_UPGRADE_KEY];

    const boxes = 3 + React.Children.count(children);
    const colWidth = Math.floor(12 / boxes);
    const renderChild = this.renderChild.bind(null, colWidth);

    const offlineClass = deviceStatusOnline === false ? "offline" : "";

    return (
      <Row>
        <Col xs={colWidth}>
          <InfoBox
            title={this.onlineTitle}
            className={`online-component ${offlineClass}`}
            desc={`${totalOnline} | ${totalHibernating}`}
            color="green"
            icon={DEVICE_ONLINE.iconClass.replace("fa-", "")}
          />
        </Col>
        <Col xs={colWidth}>
          <InfoBox
            title={DEVICE_OFFLINE.label}
            className={`online-component ${offlineClass}`}
            desc={`${totalOffline}`}
            color="red"
            icon={DEVICE_OFFLINE.iconClass.replace("fa-", "")}
          />
        </Col>
        <Col xs={colWidth}>
          <InfoBox
            title={DEVICE_NEEDS_UPGRADE.label}
            desc={`${totalNeedsSoftwareUpgrade}`}
            color="yellow"
            icon={DEVICE_NEEDS_UPGRADE.iconClass.replace("fa-", "")}
          />
        </Col>
        {React.Children.map(children, renderChild)}
      </Row>
    );
  }
}

export { DeviceStats };
